import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  deleteFromRecentSearches,
  saveToRecentSearches,
} from '/redux/action/search.action';
import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {currentScreen} from '/redux/selector/navigation.selector';
import {withHOC} from '/util/hoc.util';
import {withProps} from '/util/selector.util';

import {SearchResultItem} from './SearchResultItem';

export const SearchResultItemConnected = withHOC(
  connect(
    createStructuredSelector({
      currentScreen: currentScreen,
      userId,
      lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    }),
    dispatch => ({
      addToRecentSearches: ({item}: any) =>
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        dispatch(saveToRecentSearches({item})),
      deleteFromRecentSearches: ({item}: any) =>
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        dispatch(deleteFromRecentSearches({item})),
    }),
  ),
)(SearchResultItem);
